/**
 * Hook for LS Quick Pay button
 */
import { useEffect, useState } from 'react'
import { vn } from 'vend-number'
import { useAppSelector } from '../../../state/hooks'

import { getFeatureFromCache } from '../../../util/feature-cache'
import { selectCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'
import {
  usePaymentManager,
  useRegisterManager,
  useTrainingModeManager,
  useWebRegisterStatusManager,
} from '../../../ng-compat/hooks'
import { getOutstandingBalance } from '../../../functions/sale'
import { getMinimumLsPayAmount } from '../../../util/lspay-utils'
import { useCanTransitionToPaymentScreen } from './sale-payment-button/use-can-transition-to-payment-screen'

export const useLSQuickPay = () => {
  const paymentManager = usePaymentManager()
  const registerManager = useRegisterManager()
  const trainingModeManager = useTrainingModeManager()
  const canTransitionToPaymentScreen = useCanTransitionToPaymentScreen()

  const currentSale = useAppSelector(selectCurrentSale)
  const webRegisterStatusManager = useWebRegisterStatusManager()
  const [showQuickPayButton, setShowQuickPayButton] = useState(false)
  const [disableQuickPayButton, setDisableQuickPayButton] = useState(false)

  const trainingModeEnabled = trainingModeManager.trainingModeEnabled
  const { minimumAmount } = getMinimumLsPayAmount(
    registerManager.getActiveOutlet()
  )

  useEffect(() => {
    const shouldShowQuickPayButton = async () => {
      const hasLspayPaymentType = await paymentManager.hasLspayPaymentType()
      const ffQuickPayEnabled = getFeatureFromCache(
        'lspay_pay_with_quick_pay_experiment'
      )

      const result =
        ffQuickPayEnabled && hasLspayPaymentType && !trainingModeEnabled

      setShowQuickPayButton(result)
    }
    shouldShowQuickPayButton()
  }, [paymentManager, trainingModeEnabled, currentSale])

  useEffect(() => {
    const shouldDisableQuickPayButton = () => {
      const outstandingBalance = getOutstandingBalance(currentSale)
      const isOnline = webRegisterStatusManager.isOnline()
      const disabled =
        !isOnline ||
        vn(outstandingBalance).lte(0) ||
        vn(outstandingBalance).lt(minimumAmount) ||
        !canTransitionToPaymentScreen

      setDisableQuickPayButton(disabled)
    }
    shouldDisableQuickPayButton()
  }, [
    canTransitionToPaymentScreen,
    currentSale,
    minimumAmount,
    webRegisterStatusManager,
  ])

  return { showQuickPayButton, disableQuickPayButton }
}
